<template>
    <section class="SideBar">
        <div class="bg-image" :style="bgStyle">
            <!-- Minibanner info destacada -->
            <SidebarHighlight v-bind="highlight" />
            <ul>
                <!-- Sin link: en la home el href solo recargaba la misma URL (feedback AT&T). -->
                <li class="clc-logo">
                    <img
                        v-if="dynamicSidebar.logoSrc"
                        :src="dynamicSidebar.logoSrc"
                        :alt="logoAlt"
                    />
                    <img
                        v-else
                        src="../assets/images/rebrand-2026/att-connected-learning-center.svg"
                        :alt="logoAlt"
                    />
                </li>
                <li class="clc-info">
                    <!-- Centro actual; sin ?center= resuelto cae en "Other"/"Otro" -->
                    <p class="clc-info__label">{{ yourCenterLabel }}</p>
                    <p class="clc-info__name">{{ centerName }}</p>
                    <span class="clc-info__divider"></span>
                    <a class="clc-info__lang" href="#" @click.prevent="handleLanguageToggle">
                        {{ languageText }}
                    </a>
                </li>
            </ul>
        </div>
    </section>
</template>

<script>
import SidebarHighlight from './subcomponents/SidebarHighlight.vue';

export default {
    name: 'SideBar',
    components: { SidebarHighlight },
    props: {
        currentLanguage: {
            type: String,
            required: true,
            validator: (value) => ['en-us', 'es-es'].includes(value)
        },
        clcName: {
            type: String,
            default: ''
        },
        // dynamicSidebar (doodle): logo + fondo del rail, desde Prismic (clc_new_home_page) vía
        // CLCHomePage.getSidebarData(). Global, on/off manual.
        //   - logoSrc: vacío -> usa el asset por defecto (att-connected-learning-center.svg).
        //   - bgImage: vacío -> asset por defecto (sidebar-BG.jpg, fallback del CSS var --sidebar-bg en app.scss).
        dynamicSidebar: {
            type: Object,
            default: () => ({
                logoSrc: '',
                bgImage: ''
            })
        },

        // highlight: Minibanner info destacada. Se alimenta desde Prismic (clc_new_home_page)
        // vía CLCHomePage.getSidebarData(). Shape = props de SidebarHighlight
        // (template, textHtml, ctaLabel, ctaUrl, videoType, videoId...).
        // templates: 'empty', 'text', 'text-link', 'text-video'. Default 'empty' = no renderiza.
        highlight: {
            type: Object,
            default: () => ({
                template: 'empty'
            })
        }
    },
    computed: {
        // Inyecta la imagen de fondo dinámica como CSS var (--sidebar-bg). Si no hay bgImage,
        // no setea nada y el CSS usa el fallback del asset por defecto.
        bgStyle() {
            return this.dynamicSidebar.bgImage
                ? { '--sidebar-bg': `url(${this.dynamicSidebar.bgImage})` }
                : {};
        },
        languageText() {
            return this.currentLanguage === 'en-us'
                ? 'Cambiar a Español'
                : 'Switch to English';
        },
        yourCenterLabel() {
            return this.currentLanguage === 'en-us'
                ? 'Your center'
                : 'Tu centro';
        },
        // Mismo fallback que el campo "Your center" de StayInTheLoop.
        centerName() {
            if (this.clcName) return this.clcName;
            return this.currentLanguage === 'en-us' ? 'Other' : 'Otro';
        },
        logoAlt() {
            return this.currentLanguage === 'en-us'
                ? 'ATT Connected Learning Center'
                : 'Centro de aprendizaje conectado de ATT';
        }
    },
    methods: {
        handleLanguageToggle() {
            this.$emit('toggle-language');
        }
    }
}
</script>
